import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AuthService } from '@auth0/auth0-angular';
import { AuthSyncService } from './core/services/auth-sync/auth-sync.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    imports: [
    HttpClientModule,
    ReactiveFormsModule,
    RouterModule
]
})
export class AppComponent implements OnInit{
   constructor(private auth: AuthService,
    private router: Router,
    private authSync: AuthSyncService) {}

  ngOnInit() {
   const params = new URLSearchParams(window.location.search);
    if (params.has('code') && params.has('state')) {
      this.auth.handleRedirectCallback().subscribe({
        next: (result) => {
          if (result?.appState?.target) {
            this.router.navigateByUrl(result.appState.target);
          }
        },
        error: (err) => console.error('Redirect handling error', err),
      });
    }

    this.authSync.start();
  }
}
